import React from "react";
import "./AuthBtn.css";

const AuthBtn = ({ title, onSubmit, type }) => {
  return (
    <button
      type="button"
      className={`w-fit px-6 h-11 py-2 border-2 rounded-full text-base font-bold transition-all duration-200 ease-in-out AuthBtn disabled:opacity-50 disabled:cursor-not-allowed ${
        type === 1
          ? "bg-main border-main text-white hover:bg-mainHover hover:border-mainHover shadow-soft active:scale-[.98]"
          : "bg-white border-line text-ink hover:border-main hover:text-main active:scale-[.98]"
      }`}
      onClick={onSubmit}
    >
      {title}
    </button>
  );
};

export default AuthBtn;
